/**
 * File: useRetainersQueries.ts
 * Path: apps/admin/src/shared/hooks/useRetainersQueries.ts
 * Description: React Query wrappers over the retainers repository.
 */

import { useQuery } from "@tanstack/react-query";
import { FIRESTORE_COLLECTIONS } from "@idk/config";
import { retainersRepo } from "../services/retainersService";

export const retainersKey = [FIRESTORE_COLLECTIONS.retainers] as const;
/** Only what staff saved; the page merges it with the signed retainer contracts. */
export const useStoredRetainers = () => useQuery({ queryKey: retainersKey, queryFn: retainersRepo.list });
